const React = require('react');
const AdminFeeTable = require('../../../../../../../dumb/AdminHelpers/AdminFeeTable');
const withState = require("../../../../../../../../utils/withState");
const {apiAdminMerchantCustomerFeesGet, apiAdminMerchantCustomerFeesUpdate} = require("../../../../../../../../api/admin/retailers");
const {AdminSubtitle} = require("../../../../../../../dumb/AdminHelpers/AdminLayout");

module.exports = withState((setState, self, onMount) => {
  self.state = {
    ...self.state,
    loading: true
  }

  const id = 'ffffffff-ffff-ffff-ffff-ffffffffffff';

  const onSubmit = ({payload, confirmBearer}) => (
    apiAdminMerchantCustomerFeesUpdate({merchant_id: id, payload, confirmBearer})
  );

  onMount(() => {
    apiAdminMerchantCustomerFeesGet({id})
      .then((res = {}) => setState({list: res.list || [], loading: false}));
  })

  return (state) => {
    return state.loading
      ? (
        <span />
      ) : (
        <>
          <div className="mt25">
            <AdminSubtitle text="ONRAMP" />
          </div>
          <div className="mt25">
            <AdminFeeTable
              items={state.list}
              maxHeight={window.innerHeight - 575}
              onSubmit={onSubmit}
            />
          </div>
        </>
      )
  }
});
